<template>
    <el-dialog
            title="用户添加/编辑"
            :visible.sync="dialogVisible"
            width="650px"
            :close-on-press-escape="false"
            :close-on-click-modal="false"
            append-to-body>
        <el-form ref="form" :model="form" label-width="120px">
            <el-form-item label="用户ID" v-if="this.form.id">
                <div class="dec-bc-style">
                    <label>{{userId}}</label>
                </div>
            </el-form-item>
            <el-form-item label="用户名">
                <el-input v-model="form.username" placeholder="请输入用户名" clearable style="width: 50%"></el-input>
            </el-form-item>
            <el-form-item label="姓名">
                <el-input v-model="form.personalName" placeholder="请输入姓名" clearable style="width: 50%"></el-input>
            </el-form-item>
            <el-form-item label="电话">
                <el-input v-model="form.phone" placeholder="请输入电话" clearable style="width: 50%"></el-input>
            </el-form-item>
            <el-form-item label="角色">
                <el-select v-model="form.roleId" placeholder="请选择角色" clearable style="width: 50%">
                    <el-option
                            v-for="item in roleList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="电话" style="display: none">
              <el-input v-model="form.phone" placeholder="请输入电话" clearable style="width: 50%"></el-input>
            </el-form-item>
            <el-form-item label="指定审核范围">
                <el-select v-model="form.auditUserIds" placeholder="请选择审核范围" collapse-tags multiple clearable style="width: 50%" >
                  <el-option
                      v-for="item in userList"
                      :key="item.id"
                      :label="item.username"
                      :value="item.id">
                  </el-option>
                </el-select>
<!--                <el-checkbox-group v-model="form.auditUserIds" @change="handleChange">-->
<!--                    <el-checkbox-->
<!--                            v-for="item in userList"-->
<!--                            :key="item.id"-->
<!--                            :label="item.id"-->
<!--                    >{{item.username}}</el-checkbox>-->
<!--                </el-checkbox-group>-->

            </el-form-item>
            <el-form-item label="指定审核学校">
              <el-select v-model="form.auditSchools" placeholder="请选择审核学校" collapse-tags multiple clearable style="width: 50%">
                <el-option
                    v-for="(item,index) in schoolList"
                    :key="index"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="密码" v-if="this.form.id" >
                <el-button
                        size="mini"
                        type="text"
                        @click="handleResetPassword"
                        :disabled="allowAction.indexOf('password.reset') == -1"
                >重置密码</el-button>
            </el-form-item>
        </el-form>
        <div class="flex-middle flex-center">
            <el-button plain @click="resetForm">重置</el-button>
            <el-button plain @click="dialogVisible = false">取消</el-button>
            <el-button type="primary" @click="submit">保存</el-button>
        </div>
    </el-dialog>
</template>

<script type="text/javascript">
    import Utils from "../../../assets/js/Utils";

    export default {
        name: 'AddAccountDialog',
        props: ['successCallback'],
        data() {
            return {
                dialogVisible: false,
                allowAction: [],
                userId: null,
                form: {
                    id: null,
                    username: null,
                    personalName: null,
                    phone: null,
                    roleId: null,
                    password: null,
                    auditUserIds: [],
                    auditSchools:[]
                },
                roleList: [],
                userList: [],
                columnList:[],
                schoolList:[],

            }
        },
        watch: {
            dialogVisible(newVal, oldVal) {
                if (newVal == false) {
                  // console.log('测试9999',this.$options.data())
                  //   this.form = {}
                    Object.assign(this.$data, this.$options.data())
                }
            }
        },
        methods: {

            // 显示弹出层
            setMaskVisible(val, data) {
                this.dialogVisible = val
                this.allowAction = Utils.checkMenuOprate('system.account')
                this.form  = Object.assign({},data)
                if(!this.form.auditUserIds) {
                  // this.form.auditUserIds = []
                  this.$set(this.form,'auditUserIds',[])
                }
                if(!this.form.auditSchools) {
                    // this.form.auditSchools = []
                  this.$set(this.form,'auditSchools',[])
                }
                this.userId = this.form.id
                axios.get(Urls.URL.role_url,{params:{pageNum: 1,pageSize: 1000}}).then(res => {
                    if(res.status == '200') {
                        this.roleList = res.data.data.rows
                    }
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
                axios.get(Urls.URL.account_url,{params:{pageNum: 1,pageSize: 1000}}).then(res => {
                    if(res.status == '200') {
                        this.userList = res.data.data.rows
                        // console.log('测试userList',this.userList)
                    }
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
                axios.get(Urls.URL.form_url,{params:{pageSize: 1000,pageNum: 1}}).then(res => {
                  if(res.status == '200') {
                    this.columnList = res.data.data.rows
                    this.columnList.forEach(item => {
                      if(item.name == '报考院校') {
                        this.schoolList = item.ruleConfig.split(',')
                      }
                    })
                  }
                }).catch(err => {
                  this.loading = false
                  console.log(err)
                  // this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            },

            handleChange(val) {
                this.$forceUpdate()
            },

            resetForm() {
                this.form = {
                    id: this.userId,
                    username: null,
                    personalName: null,
                    phone: null,
                    roleId: null,
                    password: null,
                    auditUserIds: [],
                    auditSchools: []
                }
            },

            handleResetPassword() {
                axios.post(Urls.URL.account_url+'/'+this.userId+'/password/reset').then(res => {
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            },

            submit() {
                let url = Urls.URL.account_url
                let params = {}
                if(this.userId) {
                    url = url + '/' + this.userId
                } else {
                    params.password = this.form.password
                }
                params.username = this.form.username
                params.personalName = this.form.personalName
                params.phone = this.form.phone
                params.roleId = this.form.roleId
                params.auditUserIds = this.form.auditUserIds
                params.auditSchools = this.form.auditSchools

                axios.post(url,params).then(res => {
                    this.dialogVisible = false
                    this.$emit('fetchData')
                }).catch(err => {
                    this.$alert(err.response.data.errorMessage || Utils.errorText)
                })
            },

        }
    }
</script>

<style scoped lang="stylus">
    .dec-bc-style {
        flex: 1
        background-color: #F5F5F5
        width 50%
        >label {
            display inline-block
            margin-left 15px
        }
    }

    /deep/.el-select {
        width 100%
    }
</style>
